import React from "react"
import BookReview from '../component/BookReview'
import { Row, Col } from "antd"

const App = () =>{
    return(<>
    <Row justify={'center'} gutter={[0,20]}>
        <Col span={24} />
        <Col span={23} >
            <BookReview/>
        </Col>
    </Row>
    </>)
}

export default App